import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RescheduleAppointmentRequest } from '@app/models/rescheduleAppointmentRequest.model';
import { RescheduleAppointmentResponse } from '@app/models/rescheduleAppointmentResponse.model';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({
    providedIn: 'root',
})
export class AppointmentApiService {
    constructor(
        private http: HttpClient,
        private readonly configService: ConfigService
    ) {}

    private get apiUrl(): string {
        return this.configService.config.dsbApiUrl;
    }

    private get headers(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'x-api-key': this.configService.config.dsbApiSecretKey,
        });
    }

    refreshAppointments(daySmartAccountId: string): Observable<any> {
        const url = `${this.apiUrl}/api/refreshAppointments`;
        return this.http.post<any>(url, { daysmartAccountID: daySmartAccountId }, { headers: this.headers });
    }

    getAppointmentByGuid(daysmartAccountID: string, rescheduleGuid: string): Observable<any> {
        const url = `${this.apiUrl}/api/appointment/${daysmartAccountID}/${rescheduleGuid}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    rescheduleAppointment(request: RescheduleAppointmentRequest): Observable<RescheduleAppointmentResponse> {
        const url = `${this.apiUrl}/api/rescheduleAppointment`;
        return this.http.post<any>(url, { appointmentRescheduleRequest: request }, { headers: this.headers });
    }
}
